import { createSelector } from 'reselect';
import type { State as CompanyState } from '../interface';
import { getCompanyId } from './utils';
import type { State as NewsState } from '@ducks/news';
const getCompanyNewsState = (state) => {
  const company = state.company as CompanyState;
  return company.news;
};

const getNewsMap = (state) => {
  const news = state.news as NewsState;
  return news;
};

interface CompanyNews {
  headline: string;
  providerName: string;
  url: string;
  dateDiffFriendly: string;
}

export const getCurrentCompanyNews = createSelector(
  [getCompanyNewsState, getNewsMap, getCompanyId],
  (keys, news, companyId) => {
    if (
      companyId === null ||
      Object.keys(keys).length === 0 ||
      !keys[companyId]
    )
      return [];
    try {
      const companyNews = keys[companyId];
      return Object.keys(companyNews).reduce<CompanyNews[]>((acc, newsId) => {
        const currentNews = news[newsId];
        if (currentNews) {
          acc.push({
            headline: currentNews.headline,
            providerName: currentNews.providerName,
            url: currentNews.originalUrl,
            dateDiffFriendly: currentNews.dateDiffFriendly,
          });
          return acc;
        }
        return acc;
      }, []);
    } catch (error) {
      console.warn(error);
      return [];
    }
  }
);

export const getLatestNews = createSelector(
  [getCurrentCompanyNews],
  (currentNews) => currentNews.slice(0, 3)
);
